/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Вид для кнопки, управляющей скрытием/показом блоков.
   */
  app.ToggleBlocksButtonView = app.View.extend({
    
    events: {
      'click .toggle-blocks': 'toggleBlocks',
      'click .confirm-rm-legal-entity': 'removeLegalEntity',
      'click .cancel-rm-legal-entity': 'cancelRemoveLegalEntity'
    },
    
    toggleBlocks: function (e) {
      var targetBtn = $(e.currentTarget),
        blockId = targetBtn.data('block-id'),
        blocks = $('[data-block-action="' + blockId + '"]');
      
      blocks
        .stop(true, true)
        .animate({
          height: 'toggle',
          opacity: 'toggle'
        }, 500);
    },
    
    /**
     * Подтверждение удаления физического/юридического лица в личном кабинете.
     */
    removeLegalEntity: function () {
      Backbone.trigger('removeLegalEntity');
    },
    
    /**
     * Отмена удаления физического/юридического лица в личном кабинете.
     */
    cancelRemoveLegalEntity: function () {
      Backbone.trigger('cancelRemoveLegalEntity');
    }
  });
})(jQuery);

}.call(window));